import { connect } from 'react-redux';
import { useTranslation } from '@eti/providers';
import { concatenateCoverGeniusTexts } from '../../common/utils/coverGeniusApiTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { BANKRUPTCY_INSURANCE_COVER_GENIUS } from '../../products';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { useProductData } from '../../common/hook/useProductData';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = BANKRUPTCY_INSURANCE_COVER_GENIUS;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POST_BOOKING_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  ipidPolicyLinkText: 'coverGeniusIPIDPolicyLinkText',
  policyLinkText: 'coverGeniusPolicyLinkText',
  readMoreContent: 'bankruptcyInsuranceCoverGeniusAdditionalInformation',
  title: 'bankruptcyInsuranceCoverGeniusTitle'
};
const translations = {
  [MAIN_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'bankruptcyInsuranceCoverGeniusAbstractText',
    upSell: 'bankruptcyInsuranceCoverGeniusUpSellText'
  },
  [POST_BOOKING_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'bankruptcyInsuranceCoverGeniusAbstractText',
    upSell: 'bankruptcyInsuranceCoverGeniusUpSellText'
  },
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'bankruptcyInsuranceCoverGeniusAbstractSmallCard',
    upSell: 'bankruptcyInsuranceCoverGeniusUpSellTextSmallCard'
  }
};
const BankruptcyInsuranceCoverGenius = ({
  form,
  isSelected,
  order,
  productCode,
  productPosition,
  layoutType = MAIN_CARD_LAYOUT,
  className,
  sellSpecification,
  productSpecificTexts
}) => {
  const {
    t,
    resolveTranslation
  } = useTranslation();
  const texts = translations[layoutType] || {};
  const {
    productData,
    phonePrefixMarketTexts,
    rootElement,
    translation: {
      policyLinkText,
      ipidPolicyLinkText,
      readMoreContent
    }
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    sellSpecification,
    texts
  });
  const {
    name,
    abstractText,
    smallCardAbstract
  } = phonePrefixMarketTexts || {};
  if (!productData) {
    return null;
  }
  const {
    disclaimer,
    ipid,
    termsUrl = ''
  } = productSpecificTexts || {};
  const terms = {
    url: termsUrl,
    text: policyLinkText
  };
  const ipidPolicy = {
    url: ipid === null || ipid === void 0 ? void 0 : ipid.url,
    text: ipidPolicyLinkText
  };
  const policyAndIpidContent = concatenateCoverGeniusTexts({
    ipidPolicy,
    terms,
    t,
    layoutType
  });
  const readMoreContentCoverGenius = readMoreContent + concatenateCoverGeniusTexts({
    disclaimer,
    t,
    layoutType
  });
  const isSmallCardLayout = layoutType === ProductCardLayoutType.Small;
  const resolvedTitle = resolveTranslation(texts.title, name);
  const resolvedAbstractContent = resolveTranslation(texts.abstractContent, isSmallCardLayout ? smallCardAbstract : abstractText);
  const coverGeniousLinks = isSmallCardLayout ? {
    description: `${resolvedAbstractContent} ${policyAndIpidContent}`
  } : {
    additionalInformation: policyAndIpidContent,
    description: resolvedAbstractContent
  };
  const updadatedProductData = {
    ...productData,
    ...coverGeniousLinks,
    title: resolvedTitle,
    readMoreContent: readMoreContentCoverGenius
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: updadatedProductData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: updadatedProductData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(BANKRUPTCY_INSURANCE_COVER_GENIUS.name, form)(state)
});
export default connect(mapStateToProps)(BankruptcyInsuranceCoverGenius);
//# sourceMappingURL=BankruptcyInsuranceCoverGenius.js.map